export const demoEmployeesData = [
  {
    employee_id: "EMP1",
    employee_type: "FULL_TIME",
    first_name: "John",
    last_name: "Doe",
    mobile: "123-456-7890",
    email: "john@example.com",
  },
  {
    employee_id: "EMP2",
    employee_type: "FULL_TIME",
    first_name: "Jane",
    last_name: "Smith",
    mobile: "987-654-3210",
    email: "jane@example.com",
  },
];

export const demoLeadsData = [
  {
    "date": "04-Jun-2024",
    "product": "MASTER COMMERCIAL",
    "modelNumber": "RCS511TSI 50HZ/1100W",
    "serialNumber": "23KSLAAMA",
    "productMaker": "MENU",
    "company": "JSM MEHARAJ",
    "address": "JSM MEHARAJ FOODS ,ANNANAGAR, DELHI-600040",
    "billNumber":"EJD1920"
  },
  {
    "date": "04-Jun-2024",
    "product": "BAKING OVEN - 1",
    "modelNumber": "BJY-G60-1BD",
    "serialNumber": "E2189299",
    "productMaker": "BERJAYA",
    "company": "DG EQUIPMENTS",
    "address": "SRIGANDAKAVAL,ASHWATH, SUNDAKATTE,BANGALORE-560091",
    "billNumber": "I242839"
  },
];
